import { MenuItem, Select } from "@mui/material";
import type { ChangeEvent } from "react";
import type { DropdownProps } from "react-day-picker";

export function CustomSelectDropdown(props: DropdownProps) {
  const {
    options,
    value,
    onChange,
    disabled,
    name,
    id,
    "aria-label": ariaLabel,
    className,
    components: _c,
    classNames: _cn,
  } = props;

  const handleValueChange = (e: { target: { value: unknown } }) => {
    const next = e?.target?.value;

    if (onChange) {
      const syntheticEvent = {
        target: {
          value: next,
          name,
        },
      } as ChangeEvent<HTMLSelectElement>;

      onChange(syntheticEvent);
    }
  };

  return (
    <Select
      size="small"
      className={className}
      id={id}
      name={name}
      value={value ?? ""}
      disabled={disabled}
      onChange={handleValueChange}
      displayEmpty
      inputProps={{ "aria-label": ariaLabel }}
    >
      {options?.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value.toString()}
          disabled={option.disabled}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}
